export default "__VITE_ASSET__e2627bfc__"